import React from 'react';
import Navbar from '../components/Navbar';
import Projects from '../components/Projects';
import '../index.css';

const ProjectsPage = () => {
    return(
        <>
            <Navbar/>
            <Projects/>
        </>
    );
}

export default ProjectsPage;